let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4fNTY")).then(() => parcelRequire('lv8mT'));